import { connect } from 'react-redux';
import { ApplicationState } from '@mews-commander/types';
import { getSimpleUserEmail, getSimpleUserFullName } from '@mews-commander/legacy-entities/src/ducks/simpleUsers';
import { WithUserId } from '../../../types';

interface UserProfileNameProps {
    userEmail?: string;
    userFullName: string;
}

const UserProfileAvatar = ({ userEmail, userFullName }: UserProfileNameProps) => <>{userFullName || userEmail}</>;

export default connect<UserProfileNameProps, {}, WithUserId, ApplicationState>((state, { userId }) => ({
    userFullName: getSimpleUserFullName(state, { id: userId }),
    userEmail: getSimpleUserEmail(state, { id: userId }),
}))(UserProfileAvatar);
